import React, { useState, useEffect, useContext } from "react";
import moment from "moment";
import { ClickAwayListener } from "@material-ui/core";
import { DateRange } from "react-date-range";
import afterLoginApiAxios from "../../../../Util/API Calls/afterLogin";
import MyScheduleModal from "./MyScheduleModal";
import "./modal.scss";
import DoctorContext from "../../../ClinicComponents/ClinicWrapper/DoctorContext";
import { APPLICABLE_ROLE } from "../../../DashboardAppointmentsView/Constant";
import { LOCALSTORAGEKEY } from "../../../../Util/Helper/localStorageUtils";
import C2CCustomPopup from "../../../common/Popups/C2CCustomPopup";
import TimePickerPopup from "../UpdateSchedule/TimePickerPopup";
import { ARROW_TYPE, DAYS_OF_WEEK, MY_SCHEDULE_DAYS } from "../Constants";
import tickIcon from "../../../../assets/tick.svg";
import warningImg from "../../../../assets/cancelled.svg";
import C2CMiddlePopup from "../../../common/Popups/C2CMiddlePopup";
import { USER_ROLE } from "../../../../Util/constants";
import { C2CConsole } from "../../../../Util/Helper/C2CConsole";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";

const TimePickerModal = (props) => {
  const {
    open,
    handleCloseTimeModal,
    consultationType,
    slotValue,
    typeOfSlot,
    createdSlotsData,
    handleSaveTimerModal,
    handleTitle,
    staffDoctor,
  } = props;

  const [start_hr, setStartHr] = useState("09");
  const [start_min, setStartMn] = useState("00");
  const [end_hr, setEndHr] = useState("06");
  const [end_min, setEndMn] = useState("00");
  const [isStartAM, setIsStartAM] = useState(true);
  const [isEndAM, setIsEndAM] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [previousStartTime, setPreviousStartTime] = useState();
  const [previousEndTime, setPreviousEndTime] = useState();
  const [dateState, setDateState] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      rangeColors: "#F969A4",
      color: "#F969A4",
      key: "selection",
    },
  ]);
  const [selectedDateRange, setSelectedDateRange] = useState([
    {
      startDate: "",
      endDate: "",
      rangeColors: "#F969A4",
      color: "#F969A4",
      key: "selection",
    },
  ]);
  const [datePickerFocus, setDatePickerFocus] = useState([0, 1]);
  const [checkboxValue, setCheckboxValue] = useState(MY_SCHEDULE_DAYS);
  const [repeatAllDay, setAllDay] = useState(false);
  const [deleteWeek, setDeleteWeek] = useState([]);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showSuccesTimeSlot, setShowSuccesTimeSlot] = useState(false);
  const [showConflictPopup, setShowConflictPopup] = useState(false);
  const [conflictingSchedules, setConflictingSchedules] = useState([]);
  const [currentSlots, setCurrentSlots] = useState({});
  const [disableCopyAllSlots, setDisableCopyAllSlots] = useState(false);
  const [disableSaveButton, setDisableSaveButton] = useState(true);
  const [timeTitle, setTimeTitle] = useState("");
  const [addSlotModal, setAddSlotModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const stepper =
    slotValue && slotValue.value != undefined ? slotValue.value : 15; //slotValue.value; //15
  const message = "Please choose valid time slot and day(s)";
  const doctor_context = useContext(DoctorContext);
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );

  //  ====>Life Cycle

  useEffect(() => {
    setAddSlotModal(open);
  }, [open]);

  useEffect(() => {
    if (
      createdSlotsData &&
      Object.keys(createdSlotsData).length != 0 &&
      open == true &&
      typeOfSlot == "edit"
    ) {
      let sTime = moment(createdSlotsData.start_time, "HH:mm:ss")
        .format("hh:mm A")
        .split(":");
      let eTime = moment(createdSlotsData.end_time, "HH:mm:ss")
        .format("hh:mm A")
        .split(":");
      let sMin = sTime[1].split(" ");
      let eMin = eTime[1].split(" ");
      setStartHr(sTime[0]); //parseInt(sTime[0])
      setStartMn(sMin[0]); //parseInt(sMin[0])
      setEndHr(eTime[0]); //parseInt(eTime[0])
      setEndMn(eMin[0]); //parseInt(eMin[0])
      if (sMin[1] == "AM") {
        setIsStartAM(true);
      } else {
        setIsStartAM(false);
      }

      if (eMin[1] == "PM") {
        setIsEndAM(false);
      } else {
        setIsEndAM(true);
      }

      createdSlotsData.days.map((d, i) => {
        checkboxValue.map((data) => {
          if (data.value == d) {
            data.checked = true;
          }
        });
        setCheckboxValue([...checkboxValue]);
        setDeleteWeek(createdSlotsData.days);
      });
      setPreviousStartTime(
        moment(createdSlotsData.start_time, "HH:mm:ss").format("hh:mm A")
      );
      setPreviousEndTime(
        moment(createdSlotsData.end_time, "HH:mm:ss").format("hh:mm A")
      );
      let dateObj = {
        rangeColors: "#F969A4",
        color: "#F969A4",
        key: "selection",
        startDate: new Date(createdSlotsData.start_date),
        endDate: new Date(createdSlotsData.end_date),
      };
      setDateState([dateObj]);
      setSelectedDateRange([dateObj]);
    }
  }, [createdSlotsData, open]);

  useEffect(() => {
    let arr = checkboxValue;
    arr.map((data) => (data.checked = repeatAllDay));
    setCheckboxValue([...arr]);
  }, [repeatAllDay]);

  useEffect(() => {
    let selectedDays = [];
    checkboxValue.map((data) => {
      if (data.checked === true) {
        selectedDays.push(data.value);
      }
    });
    if (
      selectedDateRange?.length > 0 &&
      selectedDateRange[0].startDate &&
      selectedDateRange[0].endDate &&
      selectedDays?.length > 0
    ) {
      setDisableSaveButton(false);
    } else {
      setDisableSaveButton(true);
    }
  }, [selectedDateRange, checkboxValue]);

  useEffect(() => {
    if (selectedDateRange?.length > 0 && open) {
      let startDate = moment(selectedDateRange[0].startDate).startOf("day");
      let endDate = moment(selectedDateRange[0].endDate).startOf("day");
      let days = endDate.diff(startDate, "days");
      if (days < 7) {
        let now = startDate.clone(),
          dates = [];
        while (now.isSameOrBefore(endDate)) {
          dates.push(moment(now.format("MM/DD/YYYY")).day().toString());
          now.add(1, "days");
        }
        checkboxValue.forEach((data) => {
          data.disabled = !dates.includes(data.value);
        });
        setCheckboxValue([...checkboxValue]);
        if (days < 6) {
          setDisableCopyAllSlots(true);
        } else {
          setDisableCopyAllSlots(false);
        }
      } else {
        checkboxValue.forEach((data) => (data.disabled = false));
        setCheckboxValue([...checkboxValue]);
        setDisableCopyAllSlots(false);
      }
      setAllDay(false);
    }
  }, [selectedDateRange]);

  // ======

  //  =====> API Call

  const checkAndAddUpdateSlots = () => {
    let startTime = `${start_hr}:${start_min} ${isStartAM ? "AM" : "PM"}`;
    let endTime = `${end_hr}:${end_min} ${isEndAM ? "AM" : "PM"}`;
    let selectedDays = [];
    checkboxValue.map((data) => {
      if (data.checked === true) {
        selectedDays.push(data.value);
      }
    });
    setCurrentSlots({
      start_time: `${start_hr}:${start_min}${isStartAM ? "AM" : "PM"}`,
      end_time: `${end_hr}:${end_min}${isEndAM ? "AM" : "PM"}`,
      start_date: dateState?.length > 0 ? dateState[0]?.startDate : "",
      end_date: dateState?.length > 0 ? dateState[0]?.endDate : "",
      days: selectedDays,
    });
    if (selectedDays.length > 0) {
      let doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
      let payload = {
        consultation_type: consultationType.id,
        start_time: startTime,
        end_time: endTime,
        days_of_week: selectedDays,
        slot_type: slotValue.slotType,
        start_date:
          dateState?.length > 0
            ? moment(dateState[0]?.startDate).format("YYYY-MM-DD")
            : "",
        end_date:
          dateState?.length > 0
            ? moment(dateState[0]?.endDate).format("YYYY-MM-DD")
            : "",
        ...(consultationType.id == "4" && {
          procedure_id: consultationType.value,
        }),
        check_is_conflicting: true,
      };
      let api = "";
      if (
        (doctorClinicAssociation == "true" ||
          staffClinicAssociation == "true") &&
        doctor_context?.clinic_id
      ) {
        api =
          consultationType.id != "4"
            ? "/clinic/add-slots-by-consultation-type"
            : "/clinic/add-slots-by-procedure-id";
        payload = {
          doctor_id:
            doctorRole == USER_ROLE.DOCTOR_ADMIN ||
            doctorRole === USER_ROLE.RESOURCE_ADMIN ||
            userType == APPLICABLE_ROLE.STAFF
              ? staffDoctor.id
              : userId,
          clinic_id: doctor_context?.clinic_id,
          "authorizer-principal-id": {
            user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
            user_id: userId,
            agent: "web",
          },
          ...(userType == APPLICABLE_ROLE.STAFF && {
            staff_id: staffId,
          }),
          user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
          ...payload,
        };
      } else {
        api =
          consultationType.id != "4"
            ? "/doctor/add-slots-by-consultation-type"
            : "/doctor/add-slots-by-procedure-id";
        payload = {
          doctor_id:
            userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
          "authorizer-principal-id": {
            user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
            user_id: userId,
            agent: "web",
          },
          ...(userType == APPLICABLE_ROLE.STAFF && {
            staff_id: staffId,
          }),
          user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
          ...payload,
        };
      }

      if (!loading) {
        setLoading(true);
        const checkAndAddUpdateSlotsResponse = c2cPostApiHandler(api, payload);
        checkAndAddUpdateSlotsResponse.then(([res, error]) => {
          if (!error) {
            if (res.data.statusCode == 200) {
              setLoading(false);
              if (res.data.conflicting_schedules?.length > 0) {
                setConflictingSchedules(res.data.conflicting_schedules);
                setAddSlotModal(false);
                setShowConflictPopup(true);
              } else {
                handleSaveSlot();
              }
            } else if (res.data.statusCode == 505) {
              setLoading(false);
              setErrorMessage(res.data.message);
              setHasError(true);
            } else {
              setLoading(false);
              setErrorMessage(message);
              setHasError(true);
            }
          }
        });
      }
    }
  };

  const handleSaveSlot = (overridePayload) => {
    let startTime = `${start_hr}:${start_min} ${isStartAM ? "AM" : "PM"}`;
    let endTime = `${end_hr}:${end_min} ${isEndAM ? "AM" : "PM"}`;
    let selectedDays = [];
    let deleteDays = deleteWeek;
    checkboxValue.map((data) => {
      if (data.checked === true) {
        selectedDays.push(data.value);
      }
    });
    if (selectedDays.length > 0) {
      let doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
      let add_url_consultation = "";
      let add_url_procedure = "";
      let delete_url_consultation = "";
      let delete_url_procedure = "";
      let payload = {};
      if (
        (doctorClinicAssociation == "true" ||
          staffClinicAssociation == "true") &&
        doctor_context?.clinic_id
      ) {
        add_url_consultation = "/clinic/add-slots-by-consultation-type";
        delete_url_consultation = "/clinic/delete-slots-by-consultation-type";
        add_url_procedure = "/clinic/add-slots-by-procedure-id";
        delete_url_procedure = "/clinic/delete-slots-by-procedure-id";
        payload = {
          doctor_id:
            doctorRole == USER_ROLE.DOCTOR_ADMIN ||
            doctorRole === USER_ROLE.RESOURCE_ADMIN ||
            userType == APPLICABLE_ROLE.STAFF
              ? staffDoctor.id
              : userId,
          clinic_id: doctor_context?.clinic_id,
          "authorizer-principal-id": {
            user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
            user_id: userId,
            agent: "web",
          },
          // user_agent: "web",
          ...(userType == APPLICABLE_ROLE.STAFF && {
            staff_id: staffId,
          }),
          user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
        };
      } else {
        add_url_consultation = "/doctor/add-slots-by-consultation-type";
        delete_url_consultation = "/doctor/delete-slots-by-consultation-type";
        add_url_procedure = "/doctor/add-slots-by-procedure-id";
        delete_url_procedure = "/doctor/delete-slots-by-procedure-id";
        payload = {
          doctor_id:
            userType === APPLICABLE_ROLE.DOCTOR ? userId : staffDoctor.id,
          "authorizer-principal-id": {
            user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
            user_id: userId,
            agent: "web",
          },
          ...(userType == APPLICABLE_ROLE.STAFF && {
            staff_id: staffId,
          }),
          user_type: userType == APPLICABLE_ROLE.STAFF ? 4 : 1,
        };
      }
      if (consultationType.id != "4") {
        if (typeOfSlot == "edit") {
          afterLoginApiAxios({
            method: "post",
            url: delete_url_consultation,
            headers: {
              authorization: localStorage.getItem("id_token"),
            },
            data: {
              ...payload,
              consultation_type: consultationType.id,
              procedure_id: consultationType.value,
              days_of_week: deleteDays,
              slot_type: slotValue.slotType, //slotValue.id,
              start_time: previousStartTime,
              end_time: previousEndTime,
              start_date: createdSlotsData?.start_date,
              end_date: createdSlotsData?.end_date,
            },
          })
            .then((response) => {
              if (!loading) {
                if (response.data.statusCode == 200) {
                  if (!loading) {
                    setLoading(true);
                    afterLoginApiAxios({
                      method: "post",
                      url: add_url_consultation,
                      headers: {
                        authorization: localStorage.getItem("id_token"),
                      },
                      data: {
                        ...payload,
                        consultation_type: consultationType.id,
                        start_time: startTime,
                        end_time: endTime,
                        days_of_week: selectedDays,
                        slot_type: slotValue.slotType,
                        start_date:
                          dateState?.length > 0
                            ? moment(dateState[0]?.startDate).format(
                                "YYYY-MM-DD"
                              )
                            : "",
                        end_date:
                          dateState?.length > 0
                            ? moment(dateState[0]?.endDate).format("YYYY-MM-DD")
                            : "",
                        ...overridePayload,
                      },
                    })
                      .then((response) => {
                        if (response.data.statusCode == 200) {
                          setLoading(false);
                          handleTitle(response.data.message);
                          setShowConflictPopup(false);
                          handleResetDays();
                          handleSaveTimerModal();
                        } else if (response.data.statusCode == 505) {
                          setLoading(false);
                          setErrorMessage(response.data.message);
                          setHasError(true);
                        } else {
                          setLoading(false);
                          setErrorMessage(message);
                          setHasError(true);
                        }
                      })
                      .catch((error) => {
                        C2CConsole.error(error);
                      });
                  }
                }
              }
            })
            .catch((error) => {
              C2CConsole.error(error);
            });
        } else {
          afterLoginApiAxios({
            method: "post",
            url: add_url_consultation,
            headers: {
              authorization: localStorage.getItem("id_token"),
            },
            data: {
              consultation_type: consultationType.id,
              ...payload,
              start_time: startTime,
              end_time: endTime,
              days_of_week: selectedDays,
              slot_type: slotValue.slotType,
              start_date:
                dateState?.length > 0
                  ? moment(dateState[0]?.startDate).format("YYYY-MM-DD")
                  : "",
              end_date:
                dateState?.length > 0
                  ? moment(dateState[0]?.endDate).format("YYYY-MM-DD")
                  : "",
              ...overridePayload,
            },
          })
            .then((response) => {
              if (response.data.statusCode == 200) {
                if (handleTitle) {
                  handleTitle(response.data.message);
                }
                setShowConflictPopup(false);
                handleResetDays();
                handleSaveTimerModal();
              } else if (response.data.statusCode == 505) {
                setErrorMessage(response.data.message);
                setHasError(true);
              } else if (response.data.statusCode == 500) {
                setConflictingSchedules(response.data?.conflicting_schedules);
                setShowConflictPopup(true);
              } else {
                setErrorMessage(message);
                setHasError(true);
              }
            })
            .catch((error) => {
              C2CConsole.error(error);
            });
        }
      } else {
        if (typeOfSlot == "edit") {
          afterLoginApiAxios({
            method: "post",
            url: delete_url_procedure,
            headers: {
              authorization: localStorage.getItem("id_token"),
            },
            data: {
              ...payload,
              consultation_type: consultationType.id,
              procedure_id: consultationType.value,
              days_of_week: deleteDays,
              slot_type: slotValue.slotType,
              start_time: previousStartTime,
              end_time: previousEndTime,
              start_date: createdSlotsData?.start_date,
              end_date: createdSlotsData?.end_date,
            },
          })
            .then((response) => {
              if (response.data.statusCode == 200) {
                afterLoginApiAxios({
                  method: "post",
                  url: add_url_procedure,
                  headers: {
                    authorization: localStorage.getItem("id_token"),
                  },
                  data: {
                    ...payload,
                    consultation_type: consultationType.id,
                    procedure_id: consultationType.value,
                    start_time: startTime,
                    end_time: endTime,
                    days_of_week: selectedDays,
                    slot_type: slotValue.slotType,
                    start_date:
                      dateState?.length > 0
                        ? moment(dateState[0]?.startDate).format("YYYY-MM-DD")
                        : "",
                    end_date:
                      dateState?.length > 0
                        ? moment(dateState[0]?.endDate).format("YYYY-MM-DD")
                        : "",
                    ...overridePayload,
                  },
                })
                  .then((response) => {
                    if (response.data.statusCode == 200) {
                      handleTitle(response.data.message);
                      setShowConflictPopup(false);
                      handleResetDays();
                      handleSaveTimerModal();
                    } else if (response.data.statusCode == 505) {
                      setErrorMessage(response.data.message);
                      setHasError(true);
                    } else {
                      setErrorMessage(message);
                      setHasError(true);
                    }
                  })
                  .catch((error) => {
                    C2CConsole.error(error);
                  });
              }
            })
            .catch((error) => {
              C2CConsole.error(error);
            });
        } else {
          afterLoginApiAxios({
            method: "post",
            url: add_url_procedure,
            headers: {
              authorization: localStorage.getItem("id_token"),
            },
            data: {
              ...payload,
              consultation_type: consultationType.id,
              procedure_id: consultationType.value,
              start_time: startTime,
              end_time: endTime,
              days_of_week: selectedDays,
              slot_type: slotValue.slotType,
              start_date:
                dateState?.length > 0
                  ? moment(dateState[0]?.startDate).format("YYYY-MM-DD")
                  : "",
              end_date:
                dateState?.length > 0
                  ? moment(dateState[0]?.endDate).format("YYYY-MM-DD")
                  : "",
              ...overridePayload,
            },
          })
            .then((response) => {
              if (response.data.statusCode == 200) {
                if (handleTitle) {
                  handleTitle(response.data.message);
                }
                setShowConflictPopup(false);
                handleResetDays();
                handleSaveTimerModal();
              } else if (response.data.statusCode == 505) {
                setErrorMessage(response.data.message);
                setHasError(true);
              } else if (response.data.statusCode == 500) {
                setConflictingSchedules(response.data?.conflicting_schedules);
                setAddSlotModal(false);
                setShowConflictPopup(true);
              } else {
                setErrorMessage(message);
                setHasError(true);
              }
            })
            .catch((error) => {
              C2CConsole.error(error);
            });
        }
      }
    } else {
      setErrorMessage(message);
      setHasError(true);
    }
  };

  //  ====> Action

  const handleUpDownArrow = (type, arrowType, startOrEndTime) => {
    if (type === "hour") {
      if (arrowType === ARROW_TYPE.ARROW_UP) {
        handleHourUp(startOrEndTime);
      } else if (arrowType === ARROW_TYPE.ARROW_DOWN) {
        handleHourDown(startOrEndTime);
      }
    } else if (type === "minute") {
      if (arrowType === ARROW_TYPE.ARROW_UP) {
        handleMinUp(startOrEndTime);
      } else if (arrowType === ARROW_TYPE.ARROW_DOWN) {
        handleMinDown(startOrEndTime);
      }
    }
  };

  const handleHourUp = (startOrEndTime) => {
    if (startOrEndTime === "start") {
      let st_hr = Number(start_hr);
      if (st_hr == 12) {
        setStartHr("01");
      } else {
        if (st_hr + 1 < 10) {
          setStartHr(`0${st_hr + 1}`);
        } else {
          setStartHr(st_hr + 1);
        }
      }
    } else if (startOrEndTime === "end") {
      let et_hr = Number(end_hr);
      if (et_hr == 12) {
        setEndHr("01");
      } else {
        if (et_hr + 1 < 10) {
          setEndHr(`0${et_hr + 1}`);
        } else {
          setEndHr(et_hr + 1);
        }
      }
    }
  };

  const handleHourDown = (startOrEndTime) => {
    if (startOrEndTime === "start") {
      let st_hr = Number(start_hr);
      if (st_hr == 1) {
        setStartHr(12);
      } else {
        if (st_hr - 1 < 10) {
          setStartHr(`0${st_hr - 1}`);
        } else {
          setStartHr(st_hr - 1);
        }
      }
    } else if (startOrEndTime === "end") {
      let et_hr = Number(end_hr);
      if (et_hr == 1) {
        setEndHr(12);
      } else {
        if (et_hr - 1 < 10) {
          setEndHr(`0${et_hr - 1}`);
        } else {
          setEndHr(et_hr - 1);
        }
      }
    }
  };

  const handleMinUp = (startOrEndTime) => {
    if (startOrEndTime === "start") {
      let st_min = Number(start_min);
      if (st_min + stepper > 59) {
        let val = st_min + stepper - 60;
        if (val < 10) {
          setStartMn(`0${val}`);
        } else {
          setStartMn(val);
        }
        handleHourUp("start");
      } else {
        if (st_min + stepper > 9) {
          setStartMn(st_min + stepper);
        } else {
          setStartMn(`0${st_min + stepper}`);
        }
      }
    } else if (startOrEndTime === "end") {
      let et_min = Number(end_min);
      if (et_min + stepper > 59) {
        let val = et_min + stepper - 60;
        if (val < 10) {
          setEndMn(`0${val}`);
        } else {
          setEndMn(val);
        }
        handleHourUp("end");
      } else {
        if (et_min + stepper > 9) {
          setEndMn(et_min + stepper);
        } else {
          setEndMn(`0${et_min + stepper}`);
        }
      }
    }
  };

  const handleMinDown = (startOrEndTime) => {
    if (startOrEndTime === "start") {
      let st_min = Number(start_min);
      if (st_min - stepper < 0) {
        let minval = st_min - stepper;
        let val = 60 - Math.abs(minval);
        setStartMn(val);
      } else {
        if (st_min - stepper < 10) {
          setStartMn(`0${st_min - stepper}`);
        } else {
          setStartMn(st_min - stepper);
        }
      }
    } else if (startOrEndTime === "end") {
      let et_min = Number(end_min);
      if (et_min - stepper < 0) {
        let minval = et_min - stepper;
        let val = 60 - Math.abs(minval);
        setEndMn(val);
      } else {
        if (et_min - stepper < 10) {
          setEndMn(`0${et_min - stepper}`);
        } else {
          setEndMn(et_min - stepper);
        }
      }
    }
  };

  const handleStartAM = () => {
    setIsStartAM(!isStartAM);
  };

  const handleEndAM = () => {
    setIsEndAM(!isEndAM);
  };

  const handleHrChange = (e) => {
    if (e.target.value.length <= 2) {
      if (Number(e.target.value) > 12) {
        setStartHr("01");
      } else {
        setStartHr(e.target.value);
      }
    }
  };

  const handleMnChange = (e) => {
    if (e.target.value.length <= 2) {
      if (Number(e.target.value) > 59) {
        setStartMn(0);
      } else {
        setStartMn(e.target.value);
      }
    }
  };

  const handleEndHrChange = (e) => {
    if (e.target.value.length <= 2) {
      if (Number(e.target.value) > 12) {
        setEndHr("01");
      } else {
        setEndHr(e.target.value);
      }
    }
  };

  const handleEndMnChange = (e) => {
    if (e.target.value.length <= 2) {
      if (Number(e.target.value) > 59) {
        setEndMn("00");
      } else {
        setEndMn(e.target.value);
      }
    }
  };

  const handleDateChange = (e) => {
    setDateState([e.selection]);
    setSelectedDateRange([e.selection]);
    handleResetDays();
  };

  const handleCheckbox = (id) => {
    let arr = checkboxValue;
    arr.forEach((data) => {
      if (data.id == id) {
        data.checked = !data.checked;
      }
    });
    setCheckboxValue([...arr]);
  };

  const handleReset = () => {
    handleCloseTimeModal();
    setStartHr("09");
    setStartMn("00");
    setEndHr("06");
    setEndMn("00");
    setIsStartAM(true);
    setIsEndAM(false);
    setAllDay(false);
    setDateState([
      {
        startDate: new Date(),
        endDate: new Date(),
        rangeColors: "#F969A4",
        color: "#F969A4",
        key: "selection",
      },
    ]);
    setSelectedDateRange([
      {
        startDate: "",
        endDate: "",
      },
    ]);
    setHasError(false);
    setDisableCopyAllSlots(false);
    setShowDatePicker(false);
    handleResetDays();
  };

  const handleSaveButton = () => {
    checkAndAddUpdateSlots();
  };

  const handleCloseConflictingPopup = () => {
    setShowConflictPopup(false);
    setConflictingSchedules([]);
    handleReset();
  };

  const handleOverrideSlots = () => {
    let arr = [];
    if (conflictingSchedules?.length > 0) {
      conflictingSchedules.forEach((slot) => {
        arr.push(slot.id);
      });
    }
    let payload = {
      force_overwrite: true,
      conflicting_schedules: arr,
    };
    handleSaveSlot(payload);
  };

  const handleResetDays = () => {
    let cheboxDate = checkboxValue;
    cheboxDate.map((data) => {
      data.checked = false;
      data.disabled = false;
    });
    setCheckboxValue(cheboxDate);
    setDisableCopyAllSlots(false);
    setAllDay(false);
  };

  const getValidatedDateState = () => {
    const currentYear = new Date().getFullYear();

    const hasCurrentYear = dateState?.some((range) => {
      const startYear = range.startDate?.getFullYear?.();
      const endYear = range.endDate?.getFullYear?.();
      return startYear === currentYear || endYear === currentYear;
    });
    if (hasCurrentYear) return dateState;
    const today = new Date();
    return [
      {
        startDate: today,
        endDate: today,
        key: "selection",
        rangeColors: "#F969A4",
        color: "#F969A4",
      },
    ];
  };

  // <========

  //  ====> UI

  // Pure functions so it can be passed as children to popups ===>

  const renderDatePicker = () => {
    return (
      <div className="add-time-range-date-selector">
        <div className="add-time-range-date-selector-label">Select a Date:</div>
        <div className="dt-date-picker">
          <div
            className={
              "dt-date " +
              (selectedDateRange?.length > 0 && selectedDateRange[0]?.startDate
                ? "dt-date-active"
                : "")
            }
            style={{ marginRight: "10px" }}
            onClick={() => {
              setShowDatePicker(!showDatePicker);
              setDatePickerFocus([0, 0]);
            }}
          >
            {selectedDateRange?.length > 0 && selectedDateRange[0]?.startDate
              ? moment(dateState[0]?.startDate).format("MMMM DD, YYYY")
              : "START DATE"}
          </div>
          <div
            className={
              "dt-date " +
              (selectedDateRange?.length > 0 && selectedDateRange[0]?.endDate
                ? "dt-date-active"
                : "")
            }
            onClick={() => {
              setShowDatePicker(!showDatePicker);
              setDatePickerFocus([0, 1]);
            }}
          >
            {selectedDateRange?.length > 0 && selectedDateRange[0]?.endDate
              ? moment(dateState[0]?.endDate).format("MMMM DD, YYYY")
              : "END DATE"}
          </div>
        </div>
        {showDatePicker && (
          <div className="my-schedule-date-picker-wrapper">
            <ClickAwayListener
              onClickAway={() => {
                setShowDatePicker(false);
                setDatePickerFocus([0, 0]);
              }}
            >
              <DateRange
                dateDisplayFormat="dd/MM/yyyy"
                editableDateInputs={false}
                onChange={handleDateChange}
                moveRangeOnFirstSelection={false}
                ranges={getValidatedDateState()}
                showDateDisplay={true}
                minDate={new Date()}
                maxDate={new Date(moment().add(100, "years"))}
                startDatePlaceholder={"START DATE"}
                endDatePlaceholder={"END DATE"}
                initialFocusedRange={datePickerFocus}
                onRangeFocusChange={(e) => {
                  let arr = [0, 0];
                  if (e.toString() === arr.toString()) {
                    setShowDatePicker(false);
                  }
                }}
              />
            </ClickAwayListener>
          </div>
        )}
      </div>
    );
  };

  const renderDays = () => {
    return (
      <div className="add-time-range-day-selector">
        <div className="add-time-range-day-selector-header">Repeat Slot</div>
        <div className="add-time-range-day-selector-label-container">
          {checkboxValue.map((data, index) => (
            <div
              key={index}
              className={
                "add-time-range-day-selector-label " +
                (data.checked
                  ? "add-time-range-day-selector-label-selected"
                  : "")
              }
              onClick={() => {
                if (!data.disabled) {
                  handleCheckbox(data.id);
                }
              }}
              style={{
                cursor: data.disabled ? "not-allowed" : "",
                opacity: data.disabled ? "0.5" : "",
              }}
            >
              {data.name}
            </div>
          ))}
        </div>
        <div className="add-time-range-day-selector-copy">
          <div
            onClick={() => {
              if (!disableCopyAllSlots) {
                setAllDay(!repeatAllDay);
              }
            }}
            className={
              "add-time-range-day-selector-copy-checkbox " +
              (repeatAllDay
                ? "add-time-range-day-selector-copy-checkbox-selected"
                : "")
            }
            style={{ cursor: disableCopyAllSlots ? "not-allowed" : "" }}
          >
            {repeatAllDay && <img src={tickIcon} alt="" />}
          </div>
          <div className="add-time-range-day-selector-copy-text">
            Copy slot to all days
          </div>
        </div>
      </div>
    );
  };

  const getAddSlotsPopupContent = () => (
    <div>
      <TimePickerPopup
        open={open}
        start_hr={start_hr}
        end_hr={end_hr}
        start_min={start_min}
        end_min={end_min}
        isStartAM={isStartAM}
        isEndAM={isEndAM}
        errorMessage={errorMessage}
        hasError={hasError}
        handleCloseTimeModal={handleCloseTimeModal}
        consultationType={consultationType}
        handleStartAM={handleStartAM}
        handleEndAM={handleEndAM}
        handleHrChange={handleHrChange}
        handleMnChange={handleMnChange}
        handleEndHrChange={handleEndHrChange}
        handleEndMnChange={handleEndMnChange}
        handleUpDownArrow={handleUpDownArrow}
      />

      {renderDatePicker()}
      {renderDays()}
    </div>
  );

  const slotsOverlapContent = () => (
    <div className="slots-overlap-container">
      <div className="old-slots">
        <div className="old-slots-heading">Old Schedule</div>
        <div className="old-slots-content-wrapper">
          {conflictingSchedules?.length > 0 &&
            conflictingSchedules?.map((slots, index) => (
              <div className="old-slots-content" key={index}>
                {getSoltDetails(slots, "old")}
              </div>
            ))}
        </div>
      </div>
      <div className="new-slots">
        <div className="new-slots-heading">New Schedule</div>
        <div className="new-slots-content">
          {getSoltDetails(currentSlots, "")}
        </div>
      </div>
    </div>
  );

  const getSoltDetails = (slots, type) => {
    return (
      <>
        {`${
          slots?.start_date
            ? moment(slots.start_date).format("MMMM DD YYYY")
            : ""
        } - ${
          slots?.end_date ? moment(slots.end_date).format("MMMM DD YYYY") : ""
        }`}
        {" ("}
        {slots.days.map((dd, indx) => (
          <span key={indx}>
            {DAYS_OF_WEEK[dd]}
            {slots.days.length > 1
              ? indx != slots.days.length - 1
                ? ", "
                : ""
              : ""}
          </span>
        ))}
        {")"}
        <br />
        {`${
          slots?.start_time
            ? type === "old"
              ? moment(slots.start_time, "hh:mm:ssz").format("hh:mmA")
              : slots?.start_time
            : " "
        }-${
          slots?.end_time
            ? type === "old"
              ? moment(slots.end_time, "hh:mm:ssz").format("hh:mmA")
              : slots?.end_time
            : " "
        } `}
      </>
    );
  };
  //  <=====

  return (
    <>
      {addSlotModal && (
        <C2CCustomPopup
          openPopup={open}
          popupHeading="Add Time Slot"
          dialogClassName="add-time-picker-modal"
          middleBtn="Save"
          middleBtnDisabled={disableSaveButton}
          handleClosePopup={() => {
            handleCloseTimeModal();
            handleReset();
          }}
          handleMiddleBtnClick={handleSaveButton}
        >
          {getAddSlotsPopupContent}
        </C2CCustomPopup>
      )}

      {showConflictPopup && (
        <C2CMiddlePopup
          openPopup={showConflictPopup}
          title={
            <span>
              Schedule is Overlapping do <br /> you want to continue?
            </span>
          }
          titleImg={warningImg}
          leftBtn="Yes"
          rightBtn="No"
          handleLeftBtnClick={handleOverrideSlots}
          handleRightBtnClick={handleCloseConflictingPopup}
          handleClosePopup={handleCloseConflictingPopup}
        >
          {slotsOverlapContent}
        </C2CMiddlePopup>
      )}

      <MyScheduleModal
        name={"timeRangeModal"}
        show={showSuccesTimeSlot}
        title={timeTitle}
        okayClickHandler={() => {
          setShowSuccesTimeSlot(false);
        }}
        procedueName={consultationType.label}
      />
    </>
  );
};
export default TimePickerModal;
